import { render, staticRenderFns } from "./purchasesh.vue?vue&type=template&id=764882bc"
import script from "./purchasesh.vue?vue&type=script&lang=js"
export * from "./purchasesh.vue?vue&type=script&lang=js"
import style0 from "./purchasesh.vue?vue&type=style&index=0&id=764882bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports